<template>
  <div class="manually_add_page">
    <header class="header"><img @click="goBack" src="./../../../../assets/images/canEat/arrow_left.png" alt=""></header>
    <div class="content">
      <!-- add -->
      <div class="add_operation">
        <div class="image_upload">
          <img src="./../../../../assets/images/feedRecord/add.png" alt="">
        </div>
        <!--  -->
        <div class="add_info">
          <div class="input_item milk_input_item">
            <span>名称：</span>
            <input type="text"
            class="milk_name"
            v-model="milkName"
            @blur="getBlur"
            @input="getInput"
            @change="changeVal"
            maxlength="10"
            placeholder="最多输入10个字">
          </div>
          <div class="input_item select_input_item">
            <span>阶段：</span>
            <div class="stage_select select" @click="showStagePicker = true">
              <input class="input" v-model="stageName" type="text" placeholder="">
              <div class="triangle">
                <span></span>
              </div>
            </div>
            <van-popup v-model="showStagePicker" round position="bottom">
              <van-picker
                show-toolbar
                :columns="stage"
                value-key="name"
                @cancel="showStagePicker = false"
                @confirm="onConfirmStage"
              />
            </van-popup>
          </div>
          <div class="input_item select_input_item">
            <span>规格：</span>
            <div class="specification_select select" @click="showSpecificationPicker = true">
              <input class="input" v-model="pars.specs" type="text" placeholder="">
              <div class="triangle">
                <span></span>
              </div>
            </div>
            <van-popup v-model="showSpecificationPicker" round position="bottom">
              <van-picker
                show-toolbar
                :columns="specification"
                value-key="specs"
                @cancel="showSpecificationPicker = false"
                @confirm="onConfirmSpecification"
              />
            </van-popup>
          </div>
          <div class="input_item nums_input_item">
            <span>数量：</span>
            <div class="nums">
              <span class="symbol" @click="counter('decrease')">-</span>
              <i class="count">{{count}}</i>
              <span class="symbol" @click="counter('increase')">+</span>
              <!-- <span @click="counter('decrease')"><i>-</i></span>
              <font class="count">{{count}}</font>
              <span @click="counter('increase')"><i>+</i></span> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 保存 -->
    <div class="save_btn" @click="handleSave"><span class="save">保存</span></div>
    <van-dialog v-model="show" show-cancel-button overlayClass="mask"
    @confirm="confirm"
    @cancel="cancel">
      <div>
        <p>粮仓里已经存在该段位奶粉，可添加其他段位奶粉或同单位删除之后再添加</p>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import store from '@/store'
import { Toast } from 'vant';
import feedRecordsApi from "@/utils/axiosApi/feedRecordsApi"
import { mapState, mapActions } from "vuex";

  export default {
    name: 'ManuallyAdd',
    data() {
      return {
        show: false,
        value: '',
        flag: false,
        fileList: [],
        value1: 0,
        milkName: '',
        showStagePicker: false,
        showSpecificationPicker: false,
        stageName: '',
        stage: [{
          id: 0,
          name: '0-5',
          productDan: 'S01',
        },
        {
          id: 1,
          name: '6-11',
          productDan: 'S02',
        },
        {
          id: 0,
          name: '12-36',
          productDan: 'S03',

        }],
        specification: [{
          id: 0,
          specs: '700'
        },
        {
          id: 1,
          specs: '600'
        },
        {
          id: 2,
          specs: '500'
        }],
        count: 1,
        obj: [],
        pars: {
          memberId: 'CRM000000000043658926', // crmid
          productName: '', // 名字
          productDan: '', // 阶段
          specs: null, // 规格
          num: 1 // 桶
        },
        linshi: ''
      }
    },
    computed: {
      feedRecordsBabyBarnList() {
        return this.$store.state.feedRecordsBabyBarnList
      }
    },
    mounted() {
      console.log(this.feedRecordsBabyBarnList, 'lishishuju', 156)
      this.stageName = this.stage[0].name
      this.pars.productDan = this.stage[0].productDan
      this.pars.specs = this.specification[0].specs
      },
    methods: {
      goBack() {
        this.$router.back()
      },
      getInput(e) {
        this.milkName = this.milkName.replace(/\s+/, '')
        console.log(e,this.milkName.replace(/\s+/, ''), 'milkName')
        // if(this.milkName.length > 10) {
        //   alert('不能超出10个字')
        // }
      },
      getBlur() {
        console.log(this.milkName.length, 'blur')
      },
      changeVal() {
        console.log(this.milkName, 101)
      },
      isFlag() { // 输入牛奶名称
        if(this.milkName =="" || this.milkName.length > 10) {
          return false;
        } else {
          return true;
        }
      },
      // getVal(type) { // 规格select选择框
      //   if(type == 'stage') {
      //   console.log(this.stageSelected,'当前选择项值') // 获取的当前选择项
      //   }
      // },
      confirm() { // 弹框确定
        this.show = false
        this.$router.push({
          path: '/inventoryRecords',
          query: {
            state: 0
          }
        })
      },
      cancel() {
        console.log('我点击了取消按钮')
        this.show = false
      },
      onConfirmStage(item) {
        this.stageName = item.name
        this.pars.productDan = item.productDan
        this.showStagePicker = false;
      },
      onConfirmSpecification(item) {
        this.pars.specs = item.specs
        this.showSpecificationPicker = false;
      },
      counter(type) { // 加减操作
        if(type == 'decrease') { // 递减
          if (this.count > 1) {
				      this.count --;
			    } else {
            Toast('不能少于一桶')
		      }
        }
        else if (type == 'increase') { // 递增
          // 20 - 库存已有数量
          if (this.count < 20) {
				      this.count ++;
			    } else {
              Toast('宝宝喜欢吃新鲜奶粉，不要一次囤太多哦~')
		      }
        }
      },
      handleSave() {
          this.linshi = this.feedRecordsBabyBarnList !== null && this.feedRecordsBabyBarnList.some((ele) => {
            // console.log(ele, 175)
            return ele.productDan == this.pars.productDan
          })
        // console.log(this.linshi, 'this.linshi')
        if(!this.isFlag()) {
          Toast('不能超出10字或不填')
        } else if(this.linshi == true) {
          this.show = true
        } else {
          this.pars.productName = this.milkName
          this.pars.num = this.count
          feedRecordsApi.postManuallyAdd({}, {...this.pars}, (res) => {
            console.log(res.data, '198')
            if(res.code == '200') {
              this.$router.push({
                path: '/babyBarn'
              })
            }
          })
        }
      }
    }
  }
</script>

<style lang="less" scoped>
.manually_add_page {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #FFFFFF;
  .header {
    width: 100%;
    height: 52px;
    padding: 15px 13px 17px;
    box-sizing: border-box;
    background: #FFFFFF;
    >img {
      width: 10px;
      height: 20px;
    }
  }
  .content {
    padding: 0 13px;
    box-sizing: border-box;
    width: 100%;
    flex: 1;
    overflow-x: auto;
    .add_operation {
      width: 100%;
      display: flex;
      padding: 14px 4px;
      box-sizing: border-box;
      background: #FFFFFF;
      box-shadow: 0px 3px 10px 0px rgba(200, 201, 204, 0.5);
      border-radius: 8px;
      .image_upload {
        width: 92px;
        height: 92px;
        margin-top: 1px;
        >img {
          width: 92px;
          height: 92px;
        }
      }
      .add_info {
        width: 100%;
        flex: 1;
        padding-left: 12px;
        box-sizing: border-box;
        .input_item {
          width: 100%;
          display: flex;
          &.milk_input_item {
            height: 22px;
            padding-bottom: 4px;
            box-sizing: border-box;
            border-bottom: 1px solid #EEEEEE;
            >span {
              line-height: 18px;
            }
            .milk_name {
              line-height: 18px;
            }
          }
          &.select_input_item {
            margin-top: 8px;
            height: 24px;
            >span {
              line-height: 24px;
            }
          }
          &.nums_input_item {
            margin-top: 8px;
            height: 24px;
            >span {
              line-height: 24px;
            }
          }
          >span {
            font-size: 12px;
            color: #999999;
          }
          .milk_name {
            border: none;
            flex: 1;
          }
          .select {
            width: 110px;
            height: 24px;
            font-size: 12px;
            color: #333333;
            line-height: 24px;
            display: flex;
            border: 1px solid #DCDDDC;
            border-radius: 3px;
            overflow: hidden;
            position: relative;
            padding: 0 3px;
            box-sizing: border-box;
            .input {
              flex: 1;
              width: 100%;
              border: none;
              outline: none;
            }
            .triangle {
              width: 9px;
              height: 24px;
              >span {
                width: 0;
                height: 0;
                display: inline-block;
                border-left: 5px solid transparent;
                border-right: 5px solid transparent;
                border-top: 9px solid #333333;
              }
            }
          }
          .nums {
            width: 110px;
            display: flex;
            height: 24px;
            border: 1px solid #DCDDDC;
            border-radius: 3px;
            overflow: hidden;
            .symbol {
              width: 25px;
              height: 24px;
              line-height: 24px;
              font-size: 12px;
              text-align: center;
              color: #666666;
            }
            .count {
              flex: 1;
              text-align: center;
              font-style: normal;
              line-height: 24px;
              border-left: 1px solid #DCDDDC;
              border-right: 1px solid #DCDDDC;
              color: #666666;
            }
          }
        }
      }
    }
  }
  .save_btn {
    width: 100%;
    height: 58px;
    background: #FFFFFF;
    box-shadow: 0px 0px 8px -1px rgba(0, 0, 0, 0.2);
    padding: 11px 45px 11px 46px;
    box-sizing: border-box;
    .save {
      width: 100%;
      display: block;
      height: 36px;
      background: linear-gradient(270deg, #D4A437 0%, #E5BF5D 100%);
      border-radius: 30px;
      font-size: 16px;
      color: #FFFFFF;
      line-height: 36px;
      text-align: center;
    }
  }
  .van-dialog {
    width: 270px;
    padding: 14px 0;
    box-sizing: border-box;
  }
  .van-dialog /deep/ .van-dialog__content {
    padding: 15px 24px 15px 33px;
    box-sizing: border-box;
  }
  .van-dialog /deep/ .van-dialog__content >div >p {
    font-size: 14px;
    color: #333333;
    line-height: 20px;
  }
    /deep/ .van-dialog__footer {
      height: 41px;
    }
    /deep/ .van-dialog__footer .van-button {
      height: 41px;
      padding: 0 33px;
      box-sizing: border-box;
    }
    /deep/ .van-dialog__footer .van-button .van-button__content {
      height: 41px;
      background:  #FFFFFF;
      border-radius: 8px;
      overflow: hidden;
      font-size: 16px;
      color: #333333;
    }
    /deep/ .van-dialog__footer .van-button.van-dialog__confirm .van-button__content .van-button__text {
      color: #F470BE;
    }
    .van-popup.van-popup--round.van-popup--bottom .van-picker /deep/ .van-picker__cancel {
      font-size: 16px;
      color: #333333;
    }
    .van-popup.van-popup--round.van-popup--bottom .van-picker /deep/ .van-picker__confirm {
      font-size: 16px;
      color: #D4A437;
    }
}
</style>